export const ROUTES = {
    TICKETMASTER_ALL_EVENTS: '/ticketmaster-alle-events',
    TICKETMASTER_EVENT: '/ticketmaster-event',

    BILLETTEN_ALL_EVENTS: '/billetten-alle-events',
    BILLETTEN_EVENT: '/billetten-event',

    MULTI_ALL_MOVIES: '/multibio-alle-film',
    MULTI_FUTURE_MOVIES: '/multibio-kommende-film',
    MULTI_PROGRAM: '/multibio-program',
    MULTI_MOVIE: '/multibio-film-info',

    // new multi v2 routes
    MULTI_ALL_MOVIESV2: '/multibio-alle-filmv2',
    MULTI_FUTURE_MOVIESV2: '/multibio-kommende-filmv2',
    MULTI_PROGRAMV2: '/multibio-programv2',
    MULTI_MOVIEV2: '/multibio-film-infov2',

    HOME: '/',
    COMMERCIALS: '/reklamer',
    PAGES: '/pages',
    MOVIE: '/film-info',
    MOVIEV2: '/film-infov2', // NEW ROUTE film-infov2
    PROGRAM_AND_ALL_FUTURE_MOVIES: '/program-og-fremtidige-film',
    PROGRAM_AND_ALL_FUTURE_MOVIESV2: '/program-og-fremtidige-filmv2',  // NEW STYLE

    ALL_MOVIES: '/alle-film',
    ALL_MOVIESV2: '/alle-filmv2',  //NEW STYLE

    ALL_FUTURE_MOVIES: '/alle-fremtidige-film',
    PROGRAM: '/program',
    PROGRAMV2: '/programv2', // NEW STYLE

    // WEEK PROGRAM ROUTES
    WEEK_PROGRAM: '/uge-program',
    WEEK_PROGRAM_2: '/uge-program2',
    WEEK_PROGRAM2V2:'/uge-program2v2',
   

    FUTURE_MOVIES: '/kommende-film',
    FUTURE_MOVIESV2: '/kommende-filmv2',   // NEW ROUTE


    SPECIAL_EVENTS: '/arrangementer',
    CIRCUS: '/cirkus',

    // USER LOG IN ROUTES 
    LOGIN: '/login',
    LOGOUT:'/logout',
    CREATE_ACCOUNT: '/createaccount',
    FINISH_ACCOUNT: '/finishaccount',
    RESET_PASSWORD: '/resetpassword',
    NEW_PASSWORD:'/newpassword',
    PROFILE:'/profile',
    RESET_PASSWORD_SUCCESS: '/resetpasswordsuccess',
   

    // EBILLETS NEW WEBSITE ROUTES
        EBILLET_HOME: '/ebillet',   
        EBILLET_PROGRAM: '/ebillet-program',
      
        EBILLET_MOVIE_DETAILS: '/film-details',
        EBILLET_BIOS: '/ebillet-biografer',
        EBILLET_ALL_TRAILER: '/alle-trailere',
        EBILLET_SEARCH_FILM: '/soeg-film',
        EBILLET_FUTURE_MOVIES:'/alle-kommende-film',
  

    // new filmclub routes
    FILMCLUB: '/filmklub',
    MULTI_TICKETS: '/multi-billetter',
    FILMCLUB_CUSTOMER: '/filmklub-Kunde',
    FILMCLUB_REEPAY: '/reepayMulti',
    FILMCLUB_RECEIPT:'/filmklub-kvittering',
    FILMCLUB_REEPAY_LANDING: '/reepay-multi-Landing',

     //new route for alta belating for multi pay
    ALTA_PAY_PAYMENT_MULTI: '/altapay-betaling-multi',

    USER_TRANSACTIONS: '/mine-billetter',
    NEWSLETTERS: '/nyhedsbreve',
   
    BOOK_KVITTERING: '/book-kvittering',
    REEPAY_LANDING: '/reepay-book-landing',

   


    ORDERFLOW: {

        TICKETS: '/billetter',     
        EXTRA_PURCHASES: '/tilkøb',
        CUSTOMER: '/kunde-oplysninger',
        BIOKLUB_DK: '/biografklub-danamark',
        PAYMENT: '/betaling',
        GIFTCARDS: '/gavekort',
        DIBS: '/dibs',
        REEPAY: '/reepay',
        RECEIPT: '/kvittering',
        RESERVATION: '/reservation',

        RECEIPTQ: '/kvit',
        CANCELORBUY: '/resq',

        //new route for alta belating
        ALTA_PAY_PAYMENT:'/altapay-betaling'

    },

    NOT_FOUND: '/findes-ikke'
}